import React from 'react';
import { useMutation } from 'react-query';
import { adminAPI } from '../../../../api';
import useModal from '../../../../context/ModalContext';
import useAlarm from '../../../../context/AlarmContext';
import FormLoader from '../../../../components/FormLoader';

const DeleteModal = ({ id, refetch }) => {
  const { setAlarm } = useAlarm();
  const { closeModal } = useModal();

  const { mutate: deleteCompanyMutation, isLoading } = useMutation(
    adminAPI.deleteCompany,
    {
      onSuccess: () => {
        refetch();
        setAlarm({ type: 'success', message: 'Company removed successfully' });
        closeModal();
      },
      onError: (error) => {
        setAlarm({ type: 'error', message: error.message });
        closeModal();
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    deleteCompanyMutation({ id });
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="flex justify-between">
          <strong>Are you sure you want to remove this company?</strong>
          <div className="flex justify-end ml-4">
            <button
              type="button"
              onClick={closeModal}
              className="font-semibold p-4 rounded-lg bg-gray text-black mr-2"
            >
              No
            </button>
            <button
              type="submit"
              className="font-semibold p-4 rounded-lg bg-red text-white"
            >
              Yes
            </button>
          </div>
        </div>
      </form>
      {isLoading && <FormLoader />}
    </>
  );
};

export default DeleteModal;
